<template>
  <div class="pc-list" ref="list">
    <ExhibitionSearch @search="search" ref="reSearch" />

    <div class="pc-head">
      <div class="pc-head-handle">
        <div class="pc-head-btn">
          <button @click="deleteExhibitionInit">删除</button>
          <span></span>
          <button @click="addExhibition">添加</button>
        </div>
        <p>{{ "共" + pagination_options.total + "条" }}</p>
      </div>
    </div>

    <el-table
      class="pc-list-table"
      :data="exhibitionList"
      @sort-change="changeSort"
      v-loading="loading"
    >
      <el-table-column width="100" fixed="left">
        <template slot="header" slot-scope="header">
          <el-checkbox v-model="isSelectAll" @change="selectAll">{{
            "已选" + checked.length + "个"
          }}</el-checkbox>
        </template>
        <template slot-scope="scope">
          <el-checkbox
            v-model="scope.row.isSelect"
            @change="
              singleCheck(
                scope.$index,
                scope.row.isSelect,
                scope.row.id,
                scope.row
              )
            "
          ></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column
        fixed="left"
        prop="id"
        label="编号"
        sortable="custom"
        width="100"
      ></el-table-column>
      <el-table-column label="图片" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.cover_image" class="eltable-img">
            <img :src="scope.row.cover_image" />
          </div>
        </template>
      </el-table-column>
      <el-table-column label="展览名称" width="180" prop="chinese_name">
        <template slot-scope="scope">
          <div v-if="scope.row.chinese_name">
            {{ scope.row.chinese_name ? scope.row.chinese_name : "" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="120">
        <template slot-scope="scope">
          <!-- scope.row.status -->
          <el-switch
            v-model="scope.row.status"
            @change="changeStatus(scope.row)"
            active-color="#91CC75"
            inactive-color="#C7C7C7"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="上线时间"
        prop="online_time"
        sortable="custom"
        width="120"
      >
        <template slot-scope="scope">
          <div>{{ $dtime(scope.row.online_time).format("YYYY-MM-DD") }}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="展览时间"
        prop="exhibition_time"
        sortable="custom"
        width="120"
      >
        <template slot-scope="scope">
          <div>
            {{ $dtime(scope.row.exhibition_time).format("YYYY-MM-DD") }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="更新时间"
        prop="update_time"
        sortable="custom"
        width="120"
      >
        <template slot-scope="scope">
          <div>{{ $dtime(scope.row.update_time).format("YYYY-MM-DD") }}</div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" min-width="120">
        <template slot-scope="scope">
          <button class="btnViewDetail" @click="viewDetail(scope.row)">
            查看详情
          </button>
        </template>
      </el-table-column>
    </el-table>

    <Pagination
      v-if="exhibitionList.length > 0"
      :pagination="pagination_options"
      @goPage="goPage"
    />

    <DeleteHint
      :dialogVisible="deleteDialogVisible"
      @cancel="closeDelete"
      @delete="deleteExhibition"
    />
  </div>
</template>



<script>
import DeleteHint from "../../../template/DeleteHint";
import Pagination from "../../../componentSet/Pagination";
import ExhibitionSearch from "./ExhibitionSearch";
import {
  getExhibitionList_Api,
  deleteExhibitionList_Api,
  updateExhibitionDetail_Api,
  getExhibitionTop_Api,
} from "@/apis/exhibition.api";

export default {
  components: {
    ExhibitionSearch,
    Pagination,
    DeleteHint,
  },
  watch: {},
  data() {
    return {
      loading: false,
      deleteDialogVisible: false,
      searchRules: {
        page: 1,
        page_size: 10,
        order: "-id",
      },
      pagination_options: {
        page: 1,
        total: 0,
        take: 10,
      },
      isSelectAll: false,
      exhibitionList: [],
      checked: [],
    };
  },

  mounted() {
    this.getExhibitionListByRules(this.searchRules);
  },
  methods: {
    getExhibitionListByRules(data) {
      this.loading = true;
      getExhibitionList_Api(data).then((res) => {
        this.$set(this.pagination_options, "total", res.count);
        res.data.forEach((el) => {
          el.isSelect = false;
        });
        this.exhibitionList = res.data;
        this.loading = false;
        this.$global.success(this, "获取成功", null);
      });
    },
    changeSort(val) {
      if (val.order == "ascending") {
        this.searchRules.order = "+" + val.prop;
      }
      if (val.order == "descending") {
        this.searchRules.order = "-" + val.prop;
      }
      if (val.order == null) {
        this.searchRules.order = "-id";
      }
      this.searchRules.page = 1;
      let data = this.dealSearchRules(this.searchRules);
      this.getExhibitionListByRules(data);
      this.pagination_options.page = 1;
    },
    search(formData) {
      this.searchRules = { ...this.searchRules, page: 1, ...formData };
      let data = this.dealSearchRules(this.searchRules);
      console.log(this.searchRules, data);
      this.getExhibitionListByRules(data);
      this.pagination_options.page = 1;
    },
    dealSearchRules(formData) {
      let data = {};
      if (formData.page) {
        data.page = formData.page;
      }
      if (formData.page_size) {
        data.page_size = formData.page_size;
      }
      if (formData.order) {
        data.order = formData.order;
      }
      if (formData.name_keyword) {
        data.name_keyword = formData.name_keyword;
      }
      if (formData.host_organization_id) {
        data.host_organization_id = parseInt(formData.host_organization_id);
      }
      if (formData.status) {
        data.status = parseInt(formData.status);
      }
      return data;
    },
    deleteExhibitionInit() {
      console.log(this.checked);
      if (this.checked.length > 0) {
        getExhibitionTop_Api().then((res) => {
          let result = false;
          res.data.forEach((item) => {
            if (this.checked.includes(item.id)) {
              result = true;
            }
          });
          if (result) {
            this.$global.error(this, "此展览在推荐中，不能删除！", null);
          } else {
            this.deleteDialogVisible = true;
          }
        });
      } else {
        this.$global.error(this, "请先勾选要删除的展览！", null);
      }
    },
    addExhibition() {
      let route = this.$router.resolve({
        path: "/admin/exhibitiondetail",
        query: { method: "add" },
      });
      window.open(route.href, "_blank");
    },

    closeDelete() {
      this.deleteDialogVisible = false;
    },
    viewDetail(item) {
      let route = this.$router.resolve({
        path: "/admin/exhibitionDetail",
        query: { id: item.id, method: "update" },
      });
      window.open(route.href, "_blank");
    },
    // 全选按钮
    selectAll() {
      if (this.isSelectAll) {
        this.checked = [];
        this.exhibitionList.forEach((item, i, arr) => {
          this.$set(item, "isSelect", true);
          this.checked.push(item.id);
        });
      } else {
        this.exhibitionList.forEach((item, i, arr) => {
          item.isSelect = false;
          this.checked = [];
        });
      }
    },
    // 单选按钮
    singleCheck(index, isSelect, rowID, row) {
      if (isSelect == false) {
        this.isSelectAll = false;
        for (let i = 0; this.checked.length > i; i++) {
          if (this.checked[i] == rowID) {
            this.checked.splice(i, 1);
            return;
          }
        }
      } else {
        this.checked.push(rowID);
        if (this.checked.length == 10) {
          this.isSelectAll = true;
        }
      }
      console.log(this.checked);
    },
    changeStatus(row) {
      updateExhibitionDetail_Api({ exhibition_id: row.id, status: row.status })
        .then(() => {
          console.log("修改状态成功！");
          this.$global.success(this, "修改状态成功！", null);
        })
        .catch((res) => {
          console.log("修改状态失败！");
        });
    },
    deleteExhibition() {
      let delete_ids = { exhibition_id_list: this.checked };
      console.log("delete_ids:", delete_ids);
      deleteExhibitionList_Api(delete_ids)
        .then((res) => {
          console.log("批量删除成功！");
          this.checked = [];
          this.deleteDialogVisible = false;
          this.$global.success(this, "删除成功！");
          this.searchRules.page = 1;
          let data = this.dealSearchRules(this.searchRules);
          this.getExhibitionListByRules(data);
          this.pagination_options.page = 1;
        })
        .catch((err) => {
          console.log("批量删除失败！");
        });
    },
    goPage(pageNo) {
      this.pagination_options.page = pageNo;
      this.searchRules.page = pageNo;
      let data = this.dealSearchRules(this.searchRules);
      this.getExhibitionListByRules(data);
    },
  },
};
</script>



<style lang="scss" scoped>
.pc-list {
  @include table-head;
  .pc-pagin {
    justify-content: center !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/exhibition/component/ExhibitionTable.vue